import { UntypedFormGroup } from '@angular/forms'
import { QuestionnaireField } from '../models/questionnaire.model'

// Checkbox `specifyText` is mutated on the field object in-place by
// onSpecifyTextChange, so the cache is already current and isn't re-committed
// here. Matrix `matrixSpecifyText` is committed explicitly because the form
// stores a stringified JSON blob and needs re-parsing.
export function commitFormValuesToFields(
  fields: QuestionnaireField[],
  form: UntypedFormGroup | null | undefined
): void {
  if (!form) return
  for (const field of fields) {
    if (!field.property) continue
    const value = form.get(field.property)?.value
    if (field.isMatrix) {
      if (typeof value === 'string' && value) {
        try {
          const parsed = JSON.parse(value)
          field.matrixValue = parsed.selections || parsed || {}
          field.matrixSpecifyText = parsed.specifyText || {}
          field.initialValue = value
        } catch {
          field.matrixValue = {}
          field.matrixSpecifyText = {}
        }
      } else {
        field.matrixValue = {}
        field.matrixSpecifyText = {}
        field.initialValue = ''
      }
    } else if (field.isCheckbox) {
      field.initialValue = Array.isArray(value) ? [...value] : []
    } else {
      field.initialValue = value
    }
  }
}
